module.exports = __webpack_public_path__ + "img/software_sage.a02c86e5.jpg";